import { useAccountContext } from "~/v2/providers/AccountProvider";
import { useWorkspace } from "../../shared/workspace/Workspace.context";
import { getEffectiveWidgetSymbol } from "../../shared/workspace/workspace.utils";
import { useActivitiesController } from "./ActivitiesWidget.controller";
import { ActivitiesWidgetPresentation } from "./ActivitiesWidget.pres";

export interface ActivitiesWidgetConnectorProps {
  id: string;
}

/**
 * Read-only activities consumer. Grouped widgets filter the current page to the
 * group's published underlying (including option contracts); ungrouped widgets
 * show every activity. Never publishes symbol state back to the group.
 */
export const ActivitiesWidget = ({ id }: ActivitiesWidgetConnectorProps) => {
  const { currentAccount, product } = useAccountContext();
  const accountID = currentAccount?.id;
  // Primitive selector — safe under Zustand v5 referential-equality bailout.
  const symbol = useWorkspace((s) => getEffectiveWidgetSymbol(s, id));

  const controller = useActivitiesController({ accountID, product, symbol });

  return <ActivitiesWidgetPresentation {...controller} />;
};
